import { httpClient } from './http-client';

export const sendApplication = async (formData) => {
  const data = new FormData();

  for (const key in formData) {
    if (formData.hasOwnProperty(key)) {
      if (key === 'file' && formData.file) {
        data.append(key, formData.file);
      } else {
        data.append(key, formData[key]);
      }
    }
  }
  try {
    console.log(formData, 'formdatas');
    const response = await httpClient.post('api/send_application.php', data);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
